var map = {
	"./ar/JournalDeliveryOfSamples": "622a",
	"./ar/JournalDeliveryOfSamples.js": "622a",
	"./ar/JournalItems": "432b",
	"./ar/JournalItems.js": "432b",
	"./ar/Login": "71c6",
	"./ar/Login.js": "71c6",
	"./ar/NavigationDrawer": "b939",
	"./ar/NavigationDrawer.js": "b939",
	"./ar/PharmaceuticalForms": "0dc9",
	"./ar/PharmaceuticalForms.js": "0dc9",
	"./ar/Products": "8590",
	"./ar/Products.js": "8590",
	"./ar/ProductsStatement": "89ca",
	"./ar/ProductsStatement.js": "89ca",
	"./ar/SamplesStatement": "0c79",
	"./ar/SamplesStatement.js": "0c79",
	"./ar/Visits": "5ca4",
	"./ar/Visits.js": "5ca4",
	"./ar/VisitsGroup": "478c",
	"./ar/VisitsGroup.js": "478c",
	"./en/JournalDeliveryOfSamples": "ff35",
	"./en/JournalDeliveryOfSamples.js": "ff35",
	"./en/JournalItems": "e535",
	"./en/JournalItems.js": "e535",
	"./en/Login": "b64f",
	"./en/Login.js": "b64f",
	"./en/NavigationDrawer": "b01b",
	"./en/NavigationDrawer.js": "b01b",
	"./en/PharmaceuticalForms": "c7bf",
	"./en/PharmaceuticalForms.js": "c7bf",
	"./en/Products": "5833",
	"./en/Products.js": "5833",
	"./en/ProductsStatement": "7e97",
	"./en/ProductsStatement.js": "7e97",
	"./en/SamplesStatement": "2e74",
	"./en/SamplesStatement.js": "2e74",
	"./en/Visits": "be6d",
	"./en/Visits.js": "be6d",
	"./en/VisitsGroup": "1378",
	"./en/VisitsGroup.js": "1378"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b07b";